// src/components/ShopModal.js
import { useState } from 'react';
import { SHOP_ITEMS, enhanceCost } from '../features/game/progress';

export default function ShopModal({ open, onClose, progress, setProgress, hero, setHero }) {
  const [msg, setMsg] = useState(null);
  if (!open) return null;

  const buy = (it) => {
    if (progress.gold < it.cost) return;
    const np = { ...progress, gold: progress.gold - it.cost, inv: [...(progress.inv||[])] };

    if (it.type === 'potion') {
      np.inv.push({ id:it.id, name:it.name, type:'potion' });
    }
    if (it.type === 'gear') {
      const h = { ...hero };
      if (it.effect.atk) h.str = (h.str||5) + it.effect.atk;
      if (it.effect.int) h.int = (h.int||5) + it.effect.int;
      if (it.effect.agi) h.agi = (h.agi||5) + it.effect.agi;
      setHero(h);
      np.inv.push({ id:it.id, name:it.name, type:'gear' });
    }
    if (it.type === 'weapon') {
      const newBase = it.effect.weapon.base;
      const curBase = hero.weapon?.base || 0;
      if (newBase < curBase) return; // ❌ ห้ามอ่อนกว่า
      setHero({ ...hero, weapon: { name: it.effect.weapon.name, base: newBase, plus: 0 } });
      np.inv.push({ id:it.id, name:it.name, type:'weapon' });
    }

    setProgress(np);
  };

  // ===== Enhance แบบ RO: ติด/แตก (แตก = เท่าเดิม, ติด = +1 และ plus+1)
  const enhance = () => {
    const curBase = hero.weapon?.base || 0;
    if (!curBase) { setMsg('คุณยังไม่มีอาวุธ'); return; }
    const plus = hero.weapon?.plus || 0;
    const cost = enhanceCost(curBase);
    if (progress.gold < cost) return;

    // โอกาสติดลดลงตามระดับบวก (ขั้นต่ำ 20%)
    const successChance = Math.max(0.2, 0.6 - plus * 0.08);
    const success = Math.random() < successChance;

    setProgress({ ...progress, gold: progress.gold - cost, inv:[...(progress.inv||[]), {id:`enh_${curBase}_${plus}`, name:'Enhance Try', type:'enh'}] });

    if (success) {
      setHero({ ...hero, weapon: { ...hero.weapon, base: curBase + 1, plus: plus + 1 } });
      setMsg(`Enhance Success! (+${plus+1}) Base ${curBase} → ${curBase+1}`);
    } else {
      // แตก: คง base เท่าเดิม ไม่ลด
      setMsg(`Enhance Failed… (ยังคง Base ${curBase})`);
    }
    setTimeout(()=>setMsg(null), 2000);
  };

  const W = hero.weapon?.base || 0;
  const P = hero.weapon?.plus || 0;

  return (
    <div className="modal">
      <div className="modal-card">
        <h2>After Battle Shop</h2>
        <p>Gold: <b>{progress.gold}</b> · Weapon: <b>{hero.weapon?.name || '—'}</b> (Base {W}{P?` +${P}`:''})</p>
        {msg && <div className="note">{msg}</div>}

        <Section title="Potions">
          <div className="shop-grid">
            {SHOP_ITEMS.potions.map(it => (
              <Item key={it.id} it={it} disabled={progress.gold < it.cost} onClick={()=>buy(it)} />
            ))}
          </div>
        </Section>

        <Section title="Stat Items">
          <div className="shop-grid">
            {SHOP_ITEMS.stats.map(it => (
              <Item key={it.id} it={it} disabled={progress.gold < it.cost} onClick={()=>buy(it)} />
            ))}
          </div>
        </Section>

        <Section title="Weapons (beginner)">
          <div className="shop-grid">
            {SHOP_ITEMS.weapons.map(it => {
              const nb = it.effect.weapon.base;
              const cur = hero.weapon?.base || 0;
              const disabled = progress.gold < it.cost || nb < cur;
              return <Item key={it.id} it={it} note={`Base ${nb}`} disabled={disabled} onClick={()=>buy(it)} />;
            })}
          </div>
        </Section>

        <Section title="Enhance Weapon">
          <div className="row" style={{gap:8}}>
            <button className="btn primary" disabled={progress.gold < enhanceCost(W) || !W} onClick={enhance}>
              Try Enhance (Cost {enhanceCost(W)}) · Success {(Math.max(0.2, 0.6 - P * 0.08)*100).toFixed(0)}%
            </button>
          </div>
        </Section>

        <div className="row" style={{marginTop:10}}>
          <button className="btn primary" onClick={onClose}>Continue</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }){
  return (
    <div style={{marginTop:10}}>
      <h3 style={{margin:'6px 0'}}>{title}</h3>
      {children}
    </div>
  );
}

function Item({ it, onClick, disabled, note }) {
  return (
    <button className="shop-item" disabled={disabled} onClick={onClick}>
      <div className="shop-name">{it.name}</div>
      <div className="shop-cost">💰 {it.cost}</div>
      <div className="shop-desc">
        {it.type==='potion' && `Heal +${it.effect.heal}`}
        {it.type==='gear'   && Object.keys(it.effect).map(k => `+${it.effect[k]} ${k.toUpperCase()}`).join(', ')}
        {it.type==='weapon' && (note || '')}
      </div>
    </button>
  );
}
